import React from "react";
import { Sun, Zap, Leaf, BatteryCharging, PhoneCall } from "lucide-react";
import logo from '../../assets/images/bpknetlogo.png'
import "./homenew.css";

const Home: React.FC = () => {
    return (

        <div>

            <div className="landing-container">
                <div className="content">

                    {/* Logo */}
                    <img src={logo} alt="Company Logo" className="logo" />

                    {/* Title */}
                    <h1 className="title">Democratizing P2P Exchange of Renewable Energy Empowering Prosumers.</h1>

                    {/* Subtitle */}
                    {/* <p className="subtitle">
                        
                    </p> */}

                    {/* Launching Soon */}
                    <div className="launching">
                        Launching Soon
                    </div>

                </div>
            </div>



            <footer className="footer">
                <p>{`© 2026 BPKNet (P) Ltd. All rights reserved.`}</p>
            </footer>
        </div>
    );
};

export default Home;